export interface UserActivityLog {
  id: string;
}

export interface UserActivityLogNode {
  Id: number;
  Type: number;
  SubType: number;
  Year: number;
  Month: number;
  Value: number;
  RegionId: number;
  CreateId: number;
  CreateTime: string;
  UpdateId: number;
  UpdateTime: string;
  IsActive: Boolean;
  Note?: string;
  period?: number;
  PlanMgtId?: number;
  TertTypeName?: number;
  TertTypeVal?: number;
}

export interface UserActivityLogDataList {
  Type: number;
  NodeList: UserActivityLogNode[];
}

export interface UserAppDownloadLogParam {
  type: number[];
  start_date: string;
  end_date: string;
  region?: number;
  is_AllTime?: boolean;
  is_EditMode?: boolean;
}

export interface UserActivityLogParam {
  type: number[];
  start_date: number;
  end_date: number;
  region?: number;
  is_AllTime?: boolean;
  is_EditMode?: boolean;
}

export interface UserActivityEntities {
  UserActivityLogNode: UserActivityLogNode[];
  start_date: string;
  end_date: string;
  is_AllTime: boolean;
}
export interface ReportDiscountNode {
  id: number;
  acode: number;
  RegionId: number;
  PurchaseType: number;
  PrePeriod: number;
  NewPeriod: number;
  PrePurchaseTime: number;
  NewPurchaseTime: number;
  PrePlanMgtId: number;
  NewPlanMgtId: number;
  AccountReceivable: number;
  OfficialReceipt: number;
  UpdateId: number;
  UpdateTime: string;
}
